import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['entries', 'pagination', 'spinner'];

  initialize() {
    let options = {
      rootMargin: '200px',
    };

    this.intersectionObserver = new IntersectionObserver(entries => this.processIntersectionEntries(entries), options);
  }

  connect() {
    let controller = this;
    $(this.paginationTarget).each(function(i, component){
      controller.intersectionObserver.observe(component)
    })
  }

  disconnect() {
    let controller = this;
    $(this.paginationTarget).each(function(i, component){
      controller.intersectionObserver.unobserve(component)
    })
  }

  processIntersectionEntries(entries) {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        this.loadMore(entry.target);
      }
    });
  }

  loadMore(entryTarget) {
    let next_page = this.paginationTarget.querySelector("a[rel='next']");

    if(next_page == null) {
      if($(entryTarget.nextElementSibling.children[0]).is(":visible")){
        $(entryTarget.nextElementSibling.children[0]).hide();
        let container = $(entryTarget).parents(".component-container");
        container.height(container.height() - 20);
      }
      return;
    }

    let href = next_page.href
    let url = undefined;
    if(href.includes("/dashboards/")){
      url = new URL(href.replace("render_component", 'load_entries'))
    } else {
      url = new URL(href)
      url.searchParams.append('load_entries', true);
    }

    $(entryTarget.nextElementSibling.children[0]).show();
    Rails.ajax({
      type: 'GET',
      url: url.href,
      dataType: 'json',
      success: (response) => {
        this.entriesTarget.insertAdjacentHTML('beforeend', response.entries);
        this.paginationTarget.innerHTML = response.pagination;
        $(entryTarget.nextElementSibling.children[0]).hide();
      }
    });
  }


}